import { AppConfigHttpService } from '@services/http/app-config.http.service';
import { PolymorpheusContent } from '@taiga-ui/polymorpheus';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

type ValidationFactoryResult = Record<string, PolymorpheusContent<any> | Observable<PolymorpheusContent<any>>>;

export const validationErrorFactory = (configService: AppConfigHttpService): ValidationFactoryResult => {
  const translocoService = inject(TranslocoService);
  const config = configService.configuration.inputValidation;

  const messages = Object.keys(config).reduce(
    (acc, key) => {
      if (config[key].message) {
        acc[key] = config[key].message;
      }
      return acc;
    },
    {} as Record<string, string>,
  );

  return {
    ...messages,
    required: translocoService.translate('Ce champ est requis.'),
    maxlength: ({ requiredLength }: { requiredLength: number }) =>
      translocoService.translate('Vous ne pouvez pas entrer plus de {{requiredLength}} caractères.', {
        requiredLength,
      }),
    minlength: ({ requiredLength }: { requiredLength: number }) =>
      translocoService.translate('Vous devez entrer au moins {{requiredLength}} caractères.', { requiredLength }),
    email: translocoService.translate('Veuillez entrer une adresse email valide.'),
    pattern: translocoService.translate('Le format de ce champ est invalide.'),
    departmentRequired: translocoService.translate('Veuillez sélectionner au moins un groupe.'),
    emailExcluded: translocoService.translate('Vous ne pouvez pas ajouter cette adresse email.'),
    emailsForbidden: translocoService.translate(
      'Vous ne pouvez pas ajouter une adresse email, veuillez sélectionner un utilisateur',
    ),
    phoneNumberInvalid: translocoService.translate("Ce numéro n'est pas valide pour l'indicatif renseigné."),
    fieldsMismatch: translocoService.translate('Les champs ne correspondent pas.'),
    passwordMismatch: translocoService.translate('Les mots de passe ne correspondent pas.'),
    maxTagsReached: ({ maxTags }: { maxTags: number }) =>
      translocoService.translate('Vous ne pouvez pas ajouter plus de {{maxTags}} éléments.', { maxTags }),
  };
};
